import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg';
  const variants = {
    primary: 'bg-ballet-600 text-white hover:bg-ballet-700 hover:shadow-ballet-300/50',
    secondary: 'bg-white text-ballet-800 border-2 border-ballet-200 hover:border-ballet-400 hover:bg-ballet-50'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-45">
      {children}
      <ChevronRight className="ml-2 w-5 h-5" data-id="element-46" />
    </motion.button>;
}